import React, { useState, useEffect } from 'react';
import { getMyBookings } from '../services/api';

const Dashboard = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                const response = await getMyBookings();
                setBookings(response.data);
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch your bookings.');
                setLoading(false);
                console.error(err);
            }
        };
        fetchBookings();
    }, []);

    if (loading) return <div className="text-center mt-8">Loading your bookings...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="container mx-auto p-4">
            <h2 className="text-3xl font-bold mb-6 text-center">My Bookings</h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                {bookings.length === 0 ? (
                    <p className="text-center text-gray-600">You have no bookings yet. Go to "Book Now" to make one!</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead>
                                <tr>
                                    <th className="py-2 px-4 border-b text-left">ID</th>
                                    <th className="py-2 px-4 border-b text-left">Start Time</th>
                                    <th className="py-2 px-4 border-b text-left">End Time</th>
                                    <th className="py-2 px-4 border-b text-left">Amount</th>
                                    <th className="py-2 px-4 border-b text-left">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.map((booking) => (
                                    <tr key={booking.id}>
                                        <td className="py-2 px-4 border-b">{booking.id}</td>
                                        <td className="py-2 px-4 border-b">{new Date(booking.start_time).toLocaleString()}</td>
                                        <td className="py-2 px-4 border-b">{new Date(booking.end_time).toLocaleString()}</td>
                                        <td className="py-2 px-4 border-b">${(booking.amount / 100).toFixed(2)}</td>
                                        <td className="py-2 px-4 border-b">{booking.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dashboard;